import { type ReactNode, useMemo, useState } from 'react';
import type { StoredReader, TerminalReader } from '@frontend/payments-terminal-controller';

export interface TerminalStepContextProps {
  children?: ReactNode;
}

export type TerminalStepContextState = {
  selectedReader: StoredReader | undefined;
  setSelectedReader: React.Dispatch<React.SetStateAction<StoredReader | undefined>>;
  tempReader: TerminalReader | null;
  setTempReader: React.Dispatch<React.SetStateAction<TerminalReader | null>>;
};

export const useTerminalStepSelectedReader = () => {
  const [selectedReader, setSelectedReader] = useState<StoredReader | undefined>();

  const [tempReader, setTempReader] = useState<TerminalReader | null>(null);

  const value = useMemo(
    () => ({ selectedReader, setSelectedReader, tempReader, setTempReader }),
    [selectedReader, tempReader]
  );

  return value;
};
